import * as XLSX from 'xlsx-js-style';
import { ExcelTemplate } from '../../../interfaces';
import { fitToColumn } from '../../financial-statement/utils';
import { setColumnWidth, withHeaderStyling } from '../../../utils';
import { FollowOnModelDtoForExcel } from '../FollowOnModelTabletemplate';
import { CommitmentAllocationModelExcelExport } from 'src/app/domain/follow-on/component/commitment-allocation-model-table/commitment-allocation-model-table.component';
import { getPreparedData } from "./mapping";

export class FollowModelExcelExportStepTwo implements ExcelTemplate {
  export(data: CommitmentAllocationModelExcelExport): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheetStep2 = this.getSheetStep2(data);
    XLSX.utils.book_append_sheet(book, sheetStep2);
    return book;
  }

  getSheetStep2(data: CommitmentAllocationModelExcelExport): XLSX.WorkSheet {
    const dataForExport = prepareDateForExport(data);
    const preparedData = getPreparedData(dataForExport);

    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      ' !cols': fitToColumn(preparedData),
    };
    const whiteSpaceIndexses = [3, 11, 19];
    const wideColumns = [0, 1, 2, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18, 20, 21, 22, 23, 24, 25, 26];
    wideColumns.forEach((index) => setColumnWidth(sheet, index, 17));
    whiteSpaceIndexses.forEach((index) => setColumnWidth(sheet, index, 1));
    return withHeaderStyling(sheet);
  }
};

const prepareDateForExport = (data: CommitmentAllocationModelExcelExport): FollowOnModelDtoForExcel => {
  const exportData: FollowOnModelDtoForExcel = {
    upperHeaders: getUpperHeaders(),
    headersForLogic: getHeadersForLogic(),
    headersForDisplay: getHeadersForDisplay(),
    data,
  };
  return exportData;
};

const getHeadersForDisplay = (): string[] => {
  return ['Company', 'Investment', 'Current comp.value', null,
    'Round date', 'Post-money', 'Exit value', 'Exit probability',
    'Potential multiple', 'Risk prob. (1-10)', 'Investment allocation', null,
    'Round date', 'Post-money', 'Exit value', 'Exit probability',
    'Potential multiple', 'Risk prob. (1-10)', 'Investment allocation', null,
    'Round date', 'Post-money', 'Exit value', 'Exit probability',
    'Potential multiple', 'Risk prob. (1-10)', 'Investment allocation', null];
};

const getHeadersForLogic = (): string[] => {
  return ['Company', 'Investment', 'Current comp.value', null,
    'Round date', 'Post-money', 'Exit value', 'Exit probability',
    'Potential multiple', 'Risk prob. (1-10)', 'Investment allocation', null,
    'Round date(0)', 'Post-money(0)', 'Exit value(0)', 'Exit probability(0)',
    'Potential multiple(0)', 'Risk prob. (1-10)(0)', 'Investment allocation(0)', null,
    'Round date(1)', 'Post-money(1)', 'Exit value(1)', 'Exit probability(1)',
    'Potential multiple(1)', 'Risk prob. (1-10)(1)', 'Investment allocation(1)', null];
};

const getUpperHeaders = (): string[] => {
  return [
    '', '', '', null,
    '', '', '', 'First round', '', '', '', null,
    '', '', '', 'Second round', '', '', '', null,
    '', '', '', 'Third round', '', '', '',
  ];
};
